export const PHYSICS_LAB_PATH = '/labs/physics';
export const PHYSICS_LAB_RETURNS = {
  learn: '/learn',
  physics: '/learn/study/subjects/physics/tools',
  portal: '/portal/more',
  guest: '/learn/login',
} as const;

export function physicsLabYear(year: string | null): string | null {
  return year && /^(?:[6-9]|1[0-2]|all)$/.test(year) ? year : null;
}

export function physicsLabReturn(from: string | null, year: string | null = null): string {
  const destination =
    from && Object.prototype.hasOwnProperty.call(PHYSICS_LAB_RETURNS, from)
      ? PHYSICS_LAB_RETURNS[from as keyof typeof PHYSICS_LAB_RETURNS]
      : PHYSICS_LAB_RETURNS.guest;
  const selectedYear = physicsLabYear(year);
  return from === 'physics' && selectedYear ? `${destination}?year=${selectedYear}` : destination;
}

/** Return into the required account surface when only the other session exists. */
export function physicsLabNeedsSessionRestore(
  destination: string,
  tokens: Readonly<{ kid: string | null; user: string | null }>,
): boolean {
  const path = destination.split('?')[0];
  if (path === PHYSICS_LAB_RETURNS.learn || path === PHYSICS_LAB_RETURNS.physics)
    return !tokens.kid;
  if (path === PHYSICS_LAB_RETURNS.portal) return !tokens.user;
  return false;
}
